"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const EventsPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/EventsPopover");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const constants_1 = require("src/hello_assets/src/constants");
const EventsPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPage");
const EventsDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsDataProvider");
const EmptyState = () => {
    const eventsDataContext = (0, EventsDataProvider_1.useEventsDataContext)();
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                React.createElement(React.Fragment, null, EventsPage_1.PAGE_TITLE),
                React.createElement(EventsPopover_1.EventsPopover, null)) }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(antd_1.Result, { status: "error", icon: React.createElement(React.Fragment, null), title: "You don’t have any events yet", subTitle: React.createElement(React.Fragment, null,
                        "Please integrate the ",
                        React.createElement("a", { href: constants_1.URL_GITHUB, target: "_blank" }, "latest version of an SDK"),
                        " and follow the instructions",
                        React.createElement("br", null),
                        "to track up to 10 most important actions users can do in your dapp."), extra: React.createElement(antd_1.Button, { onClick: eventsDataContext.fetchEventNames, disabled: eventsDataContext.eventNamesState.inProgress, loading: eventsDataContext.eventNamesState.inProgress },
                        React.createElement("span", null, "Try Again")) }))));
};
exports.EmptyState = EmptyState;
